// extracted by mini-css-extract-plugin
export var subscribeNewsletter = "checkbox-module--subscribeNewsletter--2p0rL";
export var box = "checkbox-module--box--3Vgtw";
export var element = "checkbox-module--element--3KtXs";
export var unChecked = "checkbox-module--unChecked--3rn8W";
export var label = "checkbox-module--label--3hij6";